import { ComplexConfig } from "src/app/shared/interfaces/complex-exercise/complex-config";
import { ComplexSubmissionItem } from "src/app/shared/interfaces/complex-exercise/complex-submissions";
import * as fromComplexExercise from "src/app/store/actions/complex-exercise.actions";

export interface ComplexExerciseState {
  config: ComplexConfig | null;
  loading: boolean;
  errorStatus: number | null;
  teacherConfig: ComplexConfig | null;
  teacherSubmissions: ComplexSubmissionItem[];
  teacherLoading: boolean;
  teacherErrorStatus: number | null;
  isCsvDownloading: boolean;
  isBulkDownloading: boolean;
  isBulkGenerating: boolean;
  bulkTooltipKey: string;
}

export const initialState: ComplexExerciseState = {
  config: null,
  loading: false,
  errorStatus: null,
  teacherConfig: null,
  teacherSubmissions: [],
  teacherLoading: false,
  teacherErrorStatus: null,
  isCsvDownloading: false,
  isBulkDownloading: false,
  isBulkGenerating: false,
  bulkTooltipKey: "COURSES.COURSE.EXERCISE.DOWNLOAD_ALL_STUDENTS_FILES",
};

export function complexExerciseReducer(
  state = initialState,
  action: fromComplexExercise.ComplexExerciseActions,
): ComplexExerciseState {
  switch (action.type) {
    case fromComplexExercise.LOAD_COMPLEX_EXERCISE_CONFIG: {
      return {
        ...state,
        loading: true,
        errorStatus: null,
      };
    }

    case fromComplexExercise.LOAD_COMPLEX_EXERCISE_CONFIG_COMPLETED: {
      const { config } = action.payload;
      return {
        ...state,
        config,
        loading: false,
        errorStatus: null,
      };
    }

    case fromComplexExercise.LOAD_COMPLEX_EXERCISE_CONFIG_FAILED: {
      const { errorStatus } = action.payload;
      return {
        ...state,
        config: null,
        loading: false,
        errorStatus: errorStatus ?? null,
      };
    }

    case fromComplexExercise.LOAD_TEACHER_COMPLEX_EXERCISE_DATA: {
      return {
        ...state,
        teacherLoading: true,
        teacherErrorStatus: null,
      };
    }

    case fromComplexExercise.LOAD_TEACHER_COMPLEX_EXERCISE_DATA_COMPLETED: {
      const { config, submissions } = action.payload;
      return {
        ...state,
        teacherConfig: config,
        teacherSubmissions: submissions || [],
        teacherLoading: false,
        teacherErrorStatus: null,
      };
    }

    case fromComplexExercise.LOAD_TEACHER_COMPLEX_EXERCISE_DATA_FAILED: {
      const { errorStatus } = action.payload;
      return {
        ...state,
        teacherConfig: null,
        teacherSubmissions: [],
        teacherLoading: false,
        teacherErrorStatus: errorStatus ?? null,
      };
    }

    case fromComplexExercise.DOWNLOAD_COMPLEX_SUBMISSIONS_CSV: {
      return {
        ...state,
        isCsvDownloading: true,
      };
    }

    case fromComplexExercise.DOWNLOAD_COMPLEX_SUBMISSIONS_CSV_COMPLETED:
    case fromComplexExercise.DOWNLOAD_COMPLEX_SUBMISSIONS_CSV_FAILED: {
      return {
        ...state,
        isCsvDownloading: false,
      };
    }

    case fromComplexExercise.DOWNLOAD_COMPLEX_BULK_FILES: {
      return {
        ...state,
        isBulkDownloading: true,
      };
    }

    case fromComplexExercise.DOWNLOAD_COMPLEX_BULK_FILES_COMPLETED: {
      const { isGenerating, tooltipKey } = action.payload;
      return {
        ...state,
        isBulkDownloading: false,
        isBulkGenerating: isGenerating,
        bulkTooltipKey: tooltipKey,
      };
    }

    case fromComplexExercise.DOWNLOAD_COMPLEX_BULK_FILES_FAILED: {
      const { tooltipKey } = action.payload;
      return {
        ...state,
        isBulkDownloading: false,
        bulkTooltipKey: tooltipKey,
      };
    }

    default:
      return state;
  }
}
